import { render, staticRenderFns } from "./ExcelMapperWrapper.vue?vue&type=template&id=5f181c09&scoped=true"
import script from "./ExcelMapperWrapper.vue?vue&type=script&lang=ts"
export * from "./ExcelMapperWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f181c09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f181c09')) {
      api.createRecord('5f181c09', component.options)
    } else {
      api.reload('5f181c09', component.options)
    }
    module.hot.accept("./ExcelMapperWrapper.vue?vue&type=template&id=5f181c09&scoped=true", function () {
      api.rerender('5f181c09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/price-lists/ExcelMapperWrapper.vue"
export default component.exports